import React from 'react';
import { Link } from 'gatsby';
import { useTranslation } from 'react-i18next';
import { Banner } from '../components/modals/Banner';
import { useCookieConsent } from '../hooks/useCookieConsent';
import { useLocalizedPaths } from '../hooks/useLocalizedPaths';

export const CookieConsent = () => {
  const { t, i18n } = useTranslation();
  const { getLocalizedPath } = useLocalizedPaths();
  const { isVisible, acceptCookies, dismissBanner } = useCookieConsent();
  
  if (!isVisible) return null;
  
  return (
    <Banner onAccept={acceptCookies} onDismiss={dismissBanner} acceptText={t('cookieAccept')}>
      <p className="text-white text-sm md:text-base">
        {t('cookieText')}
        <Link 
          to={getLocalizedPath('/terms/#cookies')} 
          className="ml-1 text-blue-400 hover:text-blue-300 underline"
        >
          {t('cookieLearnMore')}
        </Link>
      </p>
    </Banner>
  );
};